import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ProfileAddress } from 'src/app/residence/residence.model';

@Component({
    selector: 'step-info',
    templateUrl: './info.component.html',
    styleUrls: ['./info.component.scss'],
})
export class StepInfoComponent implements OnDestroy {
    destroy$ = new Subject();

    @Input() form: FormGroup;
    @Input() instructionsStepsInfo: string;
    @Input() subTypes;
    @Input() userAddresses: ProfileAddress[] = [];
    @Input() userAddressesLoaded = false;
    @Input() selectedAddressIndex = 0;
    @Input() subTypeLocked = false;

    @Output() addressSelected = new EventEmitter<number>();
    @Output() addNewAddress = new EventEmitter<void>();

    constructor(private translateService: TranslateService) {}

    get firstName() {
        return this.form.get('firstName').value;
    }
    get lastName() {
        return this.form.get('lastName').value;
    }
    get sex() {
        return this.form.get('sex').value;
    }
    get picture() {
        return this.form.get('picture').value;
    }
    get birthDate() {
        return this.formatDate(this.form.get('birthDate').value);
    }
    get address() {
        return this.form.get('address').value;
    }
    get subType() {
        return this.form.get('subType').value;
    }

    formatDate(date: string) {
        if (!date) {
            return '';
        }
        // Extract date portion from ISO string to avoid timezone conversion issues
        let dateString = date;
        if (date.includes('T')) {
            dateString = date.split('T')[0];
        }
        // Parse date components and create Date in local timezone
        const [year, month, day] = dateString.split('-').map(Number);
        const tempDate = new Date(year, month - 1, day);
        const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };
        return new Intl.DateTimeFormat(`${this.translateService.currentLang}-CA`, options).format(tempDate);
    }

    selectAddress(index: number): void {
        this.addressSelected.emit(index);
    }

    // MAIN/OTHER subtypes aren't used in practice - anything besides RESIDENT/NONRESIDENT falls back
    // to the plain "verified" label rather than guessing a wording for them.
    getVerifiedLabel(pa: ProfileAddress): string {
        const subType = pa.orgLinks?.[0]?.subType;
        if (subType === 'RESIDENT') {
            return 'pages.profile.addresses.verifiedResident';
        }
        if (subType === 'NONRESIDENT') {
            return 'pages.profile.addresses.verifiedNonResident';
        }
        return 'pages.profile.addresses.verified';
    }

    onAddNewAddress(): void {
        this.addNewAddress.emit();
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
